import { makeStyles } from '@material-ui/core/styles'

const useAgeGroupChipStyles = makeStyles(() => ({
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 9999,
    padding: '2px 8px',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    whiteSpace: 'nowrap',
  },
  junior: {
    backgroundColor: '#EBF0F2',
    color: '#172024',
  },
  adult: {
    backgroundColor: '#E0EAFF',
    color: '#001C57',
  },
}))

export default useAgeGroupChipStyles
